import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material";

const ICON_OPTIONS = [
  { value: "folder", label: "Carpeta" },
  { value: "insert_drive_file", label: "Archivo" },
  { value: "image", label: "Imagen" },
  { value: "description", label: "Documento" },
  { value: "settings", label: "Configuración" },
  { value: "star", label: "Favorito" },
  // Agrega más iconos según necesites
];

interface IconSelectorProps {
  value: string;
  onChange: (value: string) => void;
}

export const IconSelector = ({ value, onChange }: IconSelectorProps) => {
  const handleChange = (event: SelectChangeEvent<string>) => {
    onChange(event.target.value);
  };

  return (
    <FormControl size="small" sx={{ minWidth: 120 }}>
      <InputLabel>Icono</InputLabel>
      <Select value={value} label="Icono" onChange={handleChange}>
        {ICON_OPTIONS.map((icon) => (
          <MenuItem key={icon.value} value={icon.value}>
            {icon.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
